import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.1_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_6540c120aa1d6f4810bd0f3dbb498271/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}